import * as React from 'react'
import {render} from 'react-dom'
import {JssProvider} from '@eda.yandex/ui-kit/lib/hocs/inject-sheet'
import {DeviceDetectProvider} from '@eda.yandex/ui-kit/lib/hocs/device-detect'
import {RouteManager} from '@eda.yandex/web-router'
import {BrowserRender} from '@eda.yandex/web-router/browser'
import Store from 'admin/models/Store'
import {Provider} from 'mobx-react'
import {cloneDeep} from 'lodash-es'
import {createBrowserHistory} from 'history'
import routes from 'admin/config/routes'
import DefaultError from 'admin/components/DefaultError'
import {RouterEnv, Env} from './types'
import {createProviders} from './permissions/providers'
import {logError} from 'common/lib/logger'
import {createApi} from 'common/api'
import {loadYSTextFont} from 'common/lib/load-fonts'
import Loader from './components/Loader'
import 'antd/dist/antd.less'

async function createApp () {
  const root = document.createElement('div')

  root.id = 'root'
  document.body.appendChild(root)

  const env: Env = {
    api: createApi(),
    roleProviders: createProviders()
  }
  const store = Store.create({}, env)

  const storesEnv = {
    store
  }
  const routerEnv: RouterEnv = {
    ...env,
    ...storesEnv
  }
  const history = cloneDeep(createBrowserHistory())

  const routeManager = new RouteManager<RouterEnv>(
        routerEnv,
        routes,
        history,
        DefaultError,
        () => {}
    )

  await loadYSTextFont()
  
  const {error, redirectTo} = await routeManager.updateLocation(history.location)

  if (error) {
    logError(error)
  }

  if (redirectTo) {
    location.href = redirectTo

    return
  }
  render(
    <DeviceDetectProvider isMobile={false}>
            <JssProvider>
                <Provider {...storesEnv} env={env}>
                    <>
                        <Loader />
                        <BrowserRender routeManager={routeManager} />
                    </>
                </Provider>
            </JssProvider>
        </DeviceDetectProvider>,
    root
    )
}

// tslint:disable:no-console
createApp().catch((e) => console.warn(e))

// отрисовать страницу входа
// отрисовать страницу сайдбар
// отрисовать страницы: Курьерские зоны, Расписание курьеров: Резюме графика, График по курьерам
